import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function LanderFormatter({ info }) {
  const { value: lander } = getInfo(info)
  const { id, title, slug, content_type } = lander

  if (id && title && slug && content_type) {
    return <>
      {`[${content_type.toUpperCase()}][#${id}] - ${title} (${slug})`}
    </>
  }

  return '--'
}
